import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  GetLPPromotionSetData,
  GetPromotionSetData,
} from "../../../../../ApiTS/ApiPromotionTS";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface CheckMassiveRegModalProps extends DefaultModalCommonProps {
  massiveData: any[] | null;
  confirmEvent: () => void;
  isPoint?: boolean;
}

interface IPointReg {
  uid: number;
  type: "id" | "lp";
  value: number;
  lppr_dl: null | string;
}

interface ICouponReg {
  uid: number;
  id: number;
}

export default function CheckMassiveRegModal({
  massiveData,
  confirmEvent,
  closeEvent,
  isPoint,
}: CheckMassiveRegModalProps) {
  console.log(massiveData);
  const [askRegisterModal, setAskRegisterModal] = useState(false);

  const [promData, setPromData] = useState<undefined | [string, IPointReg[]][]>(
    undefined
  );
  const [lpData, setLpData] = useState<undefined | IPointReg[]>(undefined);
  const [couponPromData, setCouponPromData] = useState<
    undefined | [string, ICouponReg[]][]
  >(undefined);

  useEffect(() => {
    if (massiveData) {
      if (!isPoint) {
        const couponObject = massiveData?.reduce((group: any, product: any) => {
          const { id } = product;

          group[id] = group[id] ?? [];
          group[id].push(product);

          return group;
        }, {});

        const couponData: [string, ICouponReg[]][] =
          Object.entries(couponObject);

        console.log(couponData);

        setCouponPromData(couponData);
      } else {
        const idData = massiveData?.filter((a) => a.type === "id");
        const idDataByPromId = idData?.reduce((group: any, product: any) => {
          const { value } = product;

          group[value] = group[value] ?? [];
          group[value].push(product);

          return group;
        }, {});
        const arrByPromId: [string, IPointReg[]][] =
          Object.entries(idDataByPromId); // id type인 경우 promId 값으로 묶기

        console.log(arrByPromId);

        setPromData(arrByPromId);

        const lpData: IPointReg[] = massiveData?.filter((a) => a.type === "lp"); // lp type인 경우 묶기
        console.log(lpData);

        setLpData(lpData);
      }
    }
  }, [massiveData, isPoint]);

  return (
    <DefaultModalLayout
      modalTitle={`${isPoint ? "포인트" : "쿠폰"} 지급 내용 확인`}
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAskRegisterModal(true)}
      isMediumModal={true}
      cancelBtnText="취소"
      confirmBtnText="지급"
    >
      <CheckTotalCount>총 {massiveData?.length ?? 0}명</CheckTotalCount>

      <CheckContent>
        <ModalLabel>내용 확인</ModalLabel>

        {promData?.map((a, i: number) => {
          const lpPromotionData = GetLPPromotionSetData(+a[0]);

          return (
            <CheckValue key={i}>
              {a[0]}_{lpPromotionData?.LPPR_NM}: {a[1]?.length ?? 0}명
            </CheckValue>
          );
        })}

        {lpData && <CheckValue>임의 지급: {lpData?.length ?? 0}명</CheckValue>}

        {couponPromData?.map((c, i: number) => {
          const promotionData = GetPromotionSetData(+c[0]);

          return (
            <CheckValue key={i}>
              {c[0]}_{promotionData?.PROM_NM}: {c[1]?.length ?? 0}명
            </CheckValue>
          );
        })}
      </CheckContent>

      <>
        {askRegisterModal && (
          <AlertModal
            title={`총 ${massiveData?.length}명에게 ${
              isPoint ? "포인트를" : "쿠폰을"
            } 지급하시겠습니까?`}
            cancelEvent={() => setAskRegisterModal(false)}
            confirmEvent={() => {
              closeEvent();
              confirmEvent();
            }}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

const CheckTotalCount = styled.div`
  width: 100%;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 10px 16px;
  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  text-align: left;
  color: #808080;
`;

const CheckContent = styled.div`
  margin: 20px 0 40px 0;
`;

const CheckValue = styled(CheckTotalCount)`
  font-weight: 500;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
